import { render, staticRenderFns } from "./SelectInput.vue?vue&type=template&id=23a10d65&"
import script from "./SelectInput.vue?vue&type=script&lang=ts&"
export * from "./SelectInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports